import AlmeWebClient from './client.js';

let client;

export function instantiateClient(settings) 
{ 
    client = new AlmeWebClient(settings); 
}
export function getClientInstance() 
{ 
    return client; 
}



// WEBPACK FOOTER //
// ./src/client-instance.js